import { Grid, makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Variant } from '@material-ui/core/styles/createTypography';
import CurrencyFormat from '../../Core/CurrencyFormat/CurrencyFormat';

interface AmountRowProps {
  name: string;
  amount?: number;
  variant?: Variant;
}

const useAmountRowStyles = makeStyles(() => ({
  name: {
    flexGrow: 1
  }
}));

const AmountRow: FC<AmountRowProps> = ({
  name,
  amount,
  variant
}: AmountRowProps) => {
  const classes = useAmountRowStyles();
  return (
    <Grid container>
      <Typography variant={variant || 'subtitle1'} className={classes.name}>
        {name}
      </Typography>
      <Typography variant={variant || 'subtitle1'} align="right">
        <CurrencyFormat amount={amount} />
      </Typography>
    </Grid>
  );
};

export default AmountRow;
